import { render } from "./StipendListTraineeView.vue?vue&type=template&id=70a3d32a&ts=true"
import script from "./StipendListTraineeView.vue?vue&type=script&lang=ts"
export * from "./StipendListTraineeView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__